<div class="container">
	<div class="progress" [attr.data-percentage]="percentage">
		<span class="progress-left">
			<span class="progress-bar" [ngClass]="{'progress-bar__full': (!(achievedValue > goalValue) && percentage === 100), 'progress-bar__half': percentage < 100, 'progress-bar__overflow': achievedValue > goalValue}"></span>
		</span>
		<span class="progress-right">
			<span class="progress-bar" [ngClass]="{'progress-bar__full': (!(achievedValue > goalValue) && percentage === 100), 'progress-bar__half': percentage < 100, 'progress-bar__overflow': achievedValue > goalValue}"></span>
		</span>

	</div>
</div>

<div class="value" *ngIf="isCurrency"><label>{{(achievedValue | currency : 'USD' : 'symbol' : '1.0-0')}}</label><span>/ {{(goalValue |
	currency : 'USD' : 'symbol' : '1.0-0')}}</span></div>
<div class="value" *ngIf="!isCurrency">
  <label class="{{achievedValueClass}}">{{achievedValue}}</label>
  <span class="{{goalValueClass}}">/ {{goalValue}}</span>
</div>
<!-- Title -->
<div class="progress-title" *ngIf="title">{{title}}</div>
